
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire09fa"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire09fa"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("isZ2V", function(module, exports) {

$parcel$export(module.exports, "default", () => $d71a3202a17af06a$export$2e2bcd8739ae039);

var $jBKhW = parcelRequire("jBKhW");

/**
 * Toast object for displaying success and error messages
 */ const $d71a3202a17af06a$var$Toast = {
    /**
   * Displays a success message using showToastify
   * @param {string} msg - The message to be displayed
   */ success (msg) {
        $d71a3202a17af06a$var$showToastify(msg, "toastify-success");
    },
    /**
   * Displays an error message using showToastify
   * @param {string} msg - The message to be displayed
   */ error (msg) {
        $d71a3202a17af06a$var$showToastify(msg, "toastify-danger");
    }
};
/**
 * Displays a toast notification
 * @param {string} msg - The message to display in the toast
 * @param {string} state - The state of the toast (e.g., 'toastify-success', 'toastify-danger')
 * @param {number} [duration=2000] - The duration (in milliseconds) for which the toast should be displayed
 * @example
 * showToastify('Product added successfully!', 'toastify-success', 2000);
 */ function $d71a3202a17af06a$var$showToastify(msg, state, duration = 2000) {
    (0, (/*@__PURE__*/$parcel$interopDefault($jBKhW)))({
        text: msg,
        duration: duration,
        newWindow: true,
        gravity: "center",
        position: "center",
        stopOnFocus: true,
        className: state
    }).showToast();
}
var $d71a3202a17af06a$export$2e2bcd8739ae039 = $d71a3202a17af06a$var$Toast;

});
parcelRegister("jBKhW", function(module, exports) {
/*!
 * Toastify js 1.12.0
 * https://github.com/apvarun/toastify-js
 * @license MIT licensed
 *
 * Copyright (C) 2018 Varun A P
 */ (function(root, factory) {
    if (0, module.exports) module.exports = factory();
    else root.Toastify = factory();
})(module.exports, function(global) {
    // Object initialization
    var Toastify = function(options) {
        // Returning a new init object
        return new Toastify.lib.init(options);
    }, // Library version
    version = "1.12.0";
    // Set the default global options
    Toastify.defaults = {
        oldestFirst: true,
        text: "Toastify is awesome!",
        node: undefined,
        duration: 3000,
        selector: undefined,
        callback: function() {},
        destination: undefined,
        newWindow: false,
        close: false,
        gravity: "toastify-top",
        positionLeft: false,
        position: "",
        backgroundColor: "",
        avatar: "",
        className: "",
        stopOnFocus: true,
        onClick: function() {},
        offset: {
            x: 0,
            y: 0
        },
        escapeMarkup: true,
        ariaLive: "polite",
        style: {
            background: ""
        }
    };
    // Defining the prototype of the object
    Toastify.lib = Toastify.prototype = {
        toastify: version,
        constructor: Toastify,
        // Initializing the object with required parameters
        init: function(options) {
            // Verifying and validating the input object
            if (!options) options = {};
            // Creating the options object
            this.options = {};
            this.toastElement = null;
            // Validating the options
            this.options.text = options.text || Toastify.defaults.text; // Display message
            this.options.node = options.node || Toastify.defaults.node; // Display content as node
            this.options.duration = options.duration === 0 ? 0 : options.duration || Toastify.defaults.duration; // Display duration
            this.options.selector = options.selector || Toastify.defaults.selector; // Parent selector
            this.options.callback = options.callback || Toastify.defaults.callback; // Callback after display
            this.options.destination = options.destination || Toastify.defaults.destination; // On-click destination
            this.options.newWindow = options.newWindow || Toastify.defaults.newWindow; // Open destination in new window
            this.options.close = options.close || Toastify.defaults.close; // Show toast close icon
            this.options.gravity = options.gravity === "bottom" ? "toastify-bottom" : Toastify.defaults.gravity; // toast position - top or bottom
            this.options.positionLeft = options.positionLeft || Toastify.defaults.positionLeft; // toast position - left or right
            this.options.position = options.position || Toastify.defaults.position; // toast position - left or right
            this.options.backgroundColor = options.backgroundColor || Toastify.defaults.backgroundColor; // toast background color
            this.options.avatar = options.avatar || Toastify.defaults.avatar; // img element src - url or a path
            this.options.className = options.className || Toastify.defaults.className; // additional class names for the toast
            this.options.stopOnFocus = options.stopOnFocus === undefined ? Toastify.defaults.stopOnFocus : options.stopOnFocus; // stop timeout on focus
            this.options.onClick = options.onClick || Toastify.defaults.onClick; // Callback after click
            this.options.offset = options.offset || Toastify.defaults.offset; // toast offset
            this.options.escapeMarkup = options.escapeMarkup !== undefined ? options.escapeMarkup : Toastify.defaults.escapeMarkup;
            this.options.ariaLive = options.ariaLive || Toastify.defaults.ariaLive;
            this.options.style = options.style || Toastify.defaults.style;
            if (options.backgroundColor) this.options.style.background = options.backgroundColor;
            // Returning the current object for chaining functions
            return this;
        },
        // Building the DOM element
        buildToast: function() {
            // Validating if the options are defined
            if (!this.options) throw "Toastify is not initialized";
            // Creating the DOM object
            var divElement = document.createElement("div");
            divElement.className = "toastify on " + this.options.className;
            // Positioning toast to left or right or center
            if (!!this.options.position) divElement.className += " toastify-" + this.options.position;
            else // To be depreciated in further versions
            if (this.options.positionLeft === true) {
                divElement.className += " toastify-left";
                console.warn("Property `positionLeft` will be depreciated in further versions. Please use `position` instead.");
            } else // Default position
            divElement.className += " toastify-right";
            // Assigning gravity of element
            divElement.className += " " + this.options.gravity;
            if (this.options.backgroundColor) // This is being deprecated in favor of using the style HTML DOM property
            console.warn('DEPRECATION NOTICE: "backgroundColor" is being deprecated. Please use the "style.background" property.');
            // Loop through our style object and apply styles to divElement
            for(var property in this.options.style)divElement.style[property] = this.options.style[property];
            // Announce the toast to screen readers
            if (this.options.ariaLive) divElement.setAttribute("aria-live", this.options.ariaLive);
            // Adding the toast message/node
            if (this.options.node && this.options.node.nodeType === Node.ELEMENT_NODE) // If we have a valid node, we insert it
            divElement.appendChild(this.options.node);
            else {
                if (this.options.escapeMarkup) divElement.innerText = this.options.text;
                else divElement.innerHTML = this.options.text;
                if (this.options.avatar !== "") {
                    var avatarElement = document.createElement("img");
                    avatarElement.src = this.options.avatar;
                    avatarElement.className = "toastify-avatar";
                    if (this.options.position == "left" || this.options.positionLeft === true) // Adding close icon on the left of content
                    divElement.appendChild(avatarElement);
                    else // Adding close icon on the right of content
                    divElement.insertAdjacentElement("afterbegin", avatarElement);
                }
            }
            // Adding a close icon to the toast
            if (this.options.close === true) {
                // Create a span for close element
                var closeElement = document.createElement("button");
                closeElement.type = "button";
                closeElement.setAttribute("aria-label", "Close");
                closeElement.className = "toast-close";
                closeElement.innerHTML = "&#10006;";
                // Triggering the removal of toast from DOM on close click
                closeElement.addEventListener("click", (function(event) {
                    event.stopPropagation();
                    this.removeElement(this.toastElement);
                    window.clearTimeout(this.toastElement.timeOutValue);
                }).bind(this));
                //Calculating screen width
                var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
                // Adding the close icon to the toast element
                // Display on the right if screen width is less than or equal to 360px
                if ((this.options.position == "left" || this.options.positionLeft === true) && width > 360) // Adding close icon on the left of content
                divElement.insertAdjacentElement("afterbegin", closeElement);
                else // Adding close icon on the right of content
                divElement.appendChild(closeElement);
            }
            // Clear timeout while toast is focused
            if (this.options.stopOnFocus && this.options.duration > 0) {
                var self = this;
                // stop countdown
                divElement.addEventListener("mouseover", function(event) {
                    window.clearTimeout(divElement.timeOutValue);
                });
                // add back the timeout
                divElement.addEventListener("mouseleave", function() {
                    divElement.timeOutValue = window.setTimeout(function() {
                        // Remove the toast from DOM
                        self.removeElement(divElement);
                    }, self.options.duration);
                });
            }
            // Adding an on-click destination path
            if (typeof this.options.destination !== "undefined") divElement.addEventListener("click", (function(event) {
                event.stopPropagation();
                if (this.options.newWindow === true) window.open(this.options.destination, "_blank");
                else window.location = this.options.destination;
            }).bind(this));
            if (typeof this.options.onClick === "function" && typeof this.options.destination === "undefined") divElement.addEventListener("click", (function(event) {
                event.stopPropagation();
                this.options.onClick();
            }).bind(this));
            // Adding offset
            if (typeof this.options.offset === "object") {
                var x = getAxisOffsetAValue("x", this.options);
                var y = getAxisOffsetAValue("y", this.options);
                var xOffset = this.options.position == "left" ? x : "-" + x;
                var yOffset = this.options.gravity == "toastify-top" ? y : "-" + y;
                divElement.style.transform = "translate(" + xOffset + "," + yOffset + ")";
            }
            // Returning the generated element
            return divElement;
        },
        // Displaying the toast
        showToast: function() {
            // Creating the DOM object for the toast
            this.toastElement = this.buildToast();
            // Getting the root element to with the toast needs to be added
            var rootElement;
            if (typeof this.options.selector === "string") rootElement = document.getElementById(this.options.selector);
            else if (this.options.selector instanceof HTMLElement || typeof ShadowRoot !== "undefined" && this.options.selector instanceof ShadowRoot) rootElement = this.options.selector;
            else rootElement = document.body;
            // Validating if root element is present in DOM
            if (!rootElement) throw "Root element is not defined";
            // Adding the DOM element
            var elementToInsert = Toastify.defaults.oldestFirst ? rootElement.firstChild : rootElement.lastChild;
            rootElement.insertBefore(this.toastElement, elementToInsert);
            // Repositioning the toasts in case multiple toasts are present
            Toastify.reposition();
            if (this.options.duration > 0) this.toastElement.timeOutValue = window.setTimeout((function() {
                // Remove the toast from DOM
                this.removeElement(this.toastElement);
            }).bind(this), this.options.duration); // Binding `this` for function invocation
            // Supporting function chaining
            return this;
        },
        hideToast: function() {
            if (this.toastElement.timeOutValue) clearTimeout(this.toastElement.timeOutValue);
            this.removeElement(this.toastElement);
        },
        // Removing the element from the DOM
        removeElement: function(toastElement) {
            // Hiding the element
            // toastElement.classList.remove("on");
            toastElement.className = toastElement.className.replace(" on", "");
            // Removing the element from DOM after transition end
            window.setTimeout((function() {
                // remove options node if any
                if (this.options.node && this.options.node.parentNode) this.options.node.parentNode.removeChild(this.options.node);
                // Remove the element from the DOM, only when the parent node was not removed before.
                if (toastElement.parentNode) toastElement.parentNode.removeChild(toastElement);
                // Calling the callback function
                this.options.callback.call(toastElement);
                // Repositioning the toasts again
                Toastify.reposition();
            }).bind(this), 400); // Binding `this` for function invocation
        }
    };
    // Positioning the toasts on the DOM
    Toastify.reposition = function() {
        // Top margins with gravity
        var topLeftOffsetSize = {
            top: 15,
            bottom: 15
        };
        var topRightOffsetSize = {
            top: 15,
            bottom: 15
        };
        var offsetSize = {
            top: 15,
            bottom: 15
        };
        // Get all toast messages on the DOM
        var allToasts = document.getElementsByClassName("toastify");
        var classUsed;
        // Modifying the position of each toast element
        for(var i = 0; i < allToasts.length; i++){
            // Getting the applied gravity
            if (containsClass(allToasts[i], "toastify-top") === true) classUsed = "toastify-top";
            else classUsed = "toastify-bottom";
            var height = allToasts[i].offsetHeight;
            classUsed = classUsed.substr(9, classUsed.length - 1);
            // Spacing between toasts
            var offset = 15;
            var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
            // Show toast in center if screen with less than or equal to 360px
            if (width <= 360) {
                // Setting the position
                allToasts[i].style[classUsed] = offsetSize[classUsed] + "px";
                offsetSize[classUsed] += height + offset;
            } else if (containsClass(allToasts[i], "toastify-left") === true) {
                // Setting the position
                allToasts[i].style[classUsed] = topLeftOffsetSize[classUsed] + "px";
                topLeftOffsetSize[classUsed] += height + offset;
            } else {
                // Setting the position
                allToasts[i].style[classUsed] = topRightOffsetSize[classUsed] + "px";
                topRightOffsetSize[classUsed] += height + offset;
            }
        }
        // Supporting function chaining
        return this;
    };
    // Helper function to get offset.
    function getAxisOffsetAValue(axis, options) {
        if (options.offset[axis]) {
            if (isNaN(options.offset[axis])) return options.offset[axis];
            else return options.offset[axis] + "px";
        }
        return "0px";
    }
    function containsClass(elem, yourClass) {
        if (!elem || typeof yourClass !== "string") return false;
        else if (elem.className && elem.className.trim().split(/\s+/gi).indexOf(yourClass) > -1) return true;
        else return false;
    }
    // Setting up the prototype for the init object
    Toastify.lib.init.prototype = Toastify.lib;
    // Returning the Toastify function to be assigned to the window object/module
    return Toastify;
});

});


parcelRegister("ez1WD", function(module, exports) {

$parcel$export(module.exports, "MESSAGES", () => $a9a5d7c3f43e7d9b$export$af7faffe10421f14);
const $a9a5d7c3f43e7d9b$export$af7faffe10421f14 = {
    ADD_PRODUCT_SUCCESS_MESSAGE: "Succeed to add the product!",
    ADD_PRODUCT_FAILED_MESSAGE: "Failed to add the product!",
    DELETE_PRODUCT_SUCCESS_MESSAGE: "Succeed to delete the product!",
    DELETE_PRODUCT_FAILED_MESSAGE: "Failed to delete the product!",
    GET_PRODUCT_FAILED_MESSAGE: "Failed to load products!",
    EDIT_PRODUCT_SUCCESS_MESSAGE: "Succeed to edit the product!",
    EDIT_PRODUCT_FAILED_MESSAGE: "Failed to edit the product!",
    NOT_FOUND: "No Results Found!",
    ADD_PRODUCT_HEADING: "Create a new product",
    EDIT_PRODUCT_HEADING: "Edit product",
    GENERAL_ERROR_MESSAGE: "An unexpected error occurred. Please try again later!"
};

});

parcelRegister("kALLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $efdc398645315d8a$export$2e2bcd8739ae039);

var $i7c8F = parcelRequire("i7c8F");

var $3vu4x = parcelRequire("3vu4x");
class $efdc398645315d8a$export$2e2bcd8739ae039 extends (0, $i7c8F.default) {
    constructor(){
        super((0, $3vu4x.API).PRODUCTS_ENDPOINT);
    }
}

});
parcelRegister("i7c8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3024bf0574c252a$export$2e2bcd8739ae039);

var $eyxGm = parcelRequire("eyxGm");

var $3vu4x = parcelRequire("3vu4x");
class $d3024bf0574c252a$var$BaseService {
    constructor(endpoint){
        this.httpClient = new (0, $eyxGm.HttpClient)({
            baseURL: (0, $3vu4x.API).BASE_URL
        });
        this.endpoint = endpoint;
    }
    /**
   * Retrieves a list of data from the API.
   * @param {Object} params - Optional parameters for API request.
   * @returns {Promise<Object[]>} An array of data objects.
   */ async getList(params = {}) {
        const queryParams = new URLSearchParams();
        for(const key in params)queryParams.append(key, params[key]);
        const url = `${this.endpoint}?${queryParams.toString()}`;
        try {
            return await this.httpClient.get(url);
        } catch (error) {
            return error;
        }
    }
    /**
   * Delete a item by its ID.
   * @param {string} id - The ID of the data.
   * @param {Object} result - The result.
   */ async deleteByID(id) {
        try {
            return await this.httpClient.delete(`${this.endpoint}/${id}`);
        } catch (error) {
            return error;
        }
    }
    /**
   * Add a new data.
   * @param {object} data - The data to be added.
   * @returns {object} - An object indicating the success status and response data.
   *                   - isSuccess: true if the operation was successful, false otherwise.
   *                   - data: The response data from the server if isSuccess is true.
   */ async add(data) {
        try {
            const response = await this.httpClient.post(this.endpoint, data);
            return {
                isSuccess: true,
                data: response
            };
        } catch (error) {
            return {
                isSuccess: false
            };
        }
    }
    /**
   * Gets a data by its ID.
   * @param {string} id - The ID of the data.
   * @returns {Object} result - The result.
   */ async getByID(id) {
        try {
            return await this.httpClient.get(`${this.endpoint}/${id}`);
        } catch (error) {
            return error;
        }
    }
    /**
   * Edit a data by its ID.
   * @param {string} id - The ID of the data.
   * @param {Object} data - The data object containing the updates to be applied to the resource.
   * @returns {object} - An object indicating the success status and response data.
   *                   - isSuccess: true if the operation was successful, false otherwise.
   *                   - data: The response data from the server if isSuccess is true.
   */ async edit(id, data) {
        try {
            const response = await this.httpClient.put(`${this.endpoint}/${id}`, data);
            return {
                isSuccess: true,
                data: response
            };
        } catch (error) {
            return {
                isSuccess: false
            };
        }
    }
}
var $d3024bf0574c252a$export$2e2bcd8739ae039 = $d3024bf0574c252a$var$BaseService;

});
parcelRegister("eyxGm", function(module, exports) {

$parcel$export(module.exports, "HttpClient", () => $a98e5e42593c883a$export$8c6ee871e681f0f4);
class $a98e5e42593c883a$export$8c6ee871e681f0f4 {
    constructor(options = {}){
        this.baseURL = options.baseURL || "";
        this.headers = {
            ...options.headers || {},
            "Content-Type": "application/json"
        };
    }
    /**
   * Send requests and receive JSON from the server.
   * @param {string} endpoint - The API endpoint.
   * @param {Object} options - Options for the request.
   * @returns {Promise<any>} - A promise with the response from the server.
   */ async fetchJSON(endpoint, options = {}) {
        const response = await fetch(this.baseURL + endpoint, {
            ...options,
            headers: {
                ...this.headers,
                ...options.headers
            }
        });
        if (!response.ok) throw new Error(response.statusText);
        if (!options.parseResponse && response.status !== 204) return await response.json();
        return undefined;
    }
    /**
   * Set a header for the request.
   * @param {string} key - The name of the header.
   * @param {string} value - The value of the header.
   * @returns {HttpClient} - Returns the HttpClient object itself for chaining.
   */ setHeader(key, value) {
        this.headers[key] = value;
        return this;
    }
    /**
   * Get the header set for the request.
   * @param {string} key - The name of the header.
   * @returns {string | undefined} - Returns the value of the header if exists, otherwise returns undefined.
   */ getHeader(key) {
        this.headers[key];
    }
    /**
   * Sends a GET request to the specified endpoint.
   * @param {string} endpoint - The API endpoint.
   * @param {Object} options - Options for the request.
   * @returns {Promise<any>} - A promise with the response from the server.
   */ async get(endpoint, options = {}) {
        try {
            return await this.fetchJSON(endpoint, {
                ...options,
                method: "GET"
            });
        } catch (error) {
            throw new Error("Error during GET request:", error);
        }
    }
    /**
   * Sends a POST request to the specified endpoint.
   * @param {string} endpoint - The API endpoint.
   * @param {Object} body - The request body (data).
   * @param {Object} options - Options for the request.
   * @returns {Promise<any>} - A promise with the response from the server.
   */ async post(endpoint, body, options = {}) {
        try {
            return await this.fetchJSON(endpoint, {
                ...options,
                body: body ? JSON.stringify(body) : undefined,
                method: "POST"
            });
        } catch (error) {
            throw new Error("Error during POST request:", error);
        }
    }
    /**
   * Sends a PUT request to the specified endpoint.
   * @param {string} endpoint - The API endpoint.
   * @param {Object} body - The request body (data).
   * @param {Object} options - Options for the request.
   * @returns {Promise<any>} - A promise with the response from the server.
   */ async put(endpoint, body, options = {}) {
        try {
            return await this.fetchJSON(endpoint, {
                ...options,
                body: body ? JSON.stringify(body) : undefined,
                method: "PUT"
            });
        } catch (error) {
            throw new Error("Error during PUT request:", error);
        }
    }
    /**
   * Sends a DELETE request to the specified endpoint.
   * @param {string} endpoint - The API endpoint.
   * @param {Object} options - Options for the request.
   * @returns {Promise<any>} - A promise with the response from the server.
   */ async delete(endpoint, options = {}) {
        try {
            return await this.fetchJSON(endpoint, {
                ...options,
                method: "DELETE"
            });
        } catch (error) {
            throw new Error("Error during DELETE request:", error);
        }
    }
}

});

parcelRegister("3vu4x", function(module, exports) {

$parcel$export(module.exports, "API", () => $28db9811cc21eb03$export$2c4e825dc9120f87);
const $28db9811cc21eb03$export$2c4e825dc9120f87 = {
    BASE_URL: "https://663896844253a866a24e6014.mockapi.io/api/",
    PRODUCTS_ENDPOINT: "products"
};

});



parcelRegister("9St6j", function(module, exports) {

$parcel$export(module.exports, "default", () => $730fbb0939930a72$export$2e2bcd8739ae039);

var $fKiV7 = parcelRequire("fKiV7");

var $d0CfO = parcelRequire("d0CfO");

var $91ZXl = parcelRequire("91ZXl");

var $ez1WD = parcelRequire("ez1WD");

var $5KXXR = parcelRequire("5KXXR");
class $730fbb0939930a72$export$2e2bcd8739ae039 {
    /**
   * Displays product list of products on the view.
   * @param {Object[]} products - An array of product objects to be displayed.
   */ renderProducts(products) {
        const mainContent = document.getElementById("product-list");
        if (!Array.isArray(products)) {
            mainContent.innerHTML = `<span class="main-title">${(0, $ez1WD.MESSAGES).NOT_FOUND}</span>`;
            return;
        }
        let productListHTML = '<div class="card-product-list">';
        products.forEach((product)=>{
            productListHTML += this.renderProductCard(product);
        });
        productListHTML += "</div>";
        mainContent.innerHTML = productListHTML;
    }
    /**
   * Create HTML markup for a product card.
   * @param {Object} product - The product object containing id, name, price, imageURL, and quantity.
   * @returns {string} - The HTML markup for the product card.
   */ renderProductCard(product) {
        const { id: id, name: name, price: price, imageURL: imageURL, quantity: quantity } = product;
        return `
    <div class="card card-product" data-id="${id}">
      <div class="card-header">
        <div class="delete-product-icon" data-product-id="${id}">
          <svg width="15" height="15">
            <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($fKiV7))}#delete-icon" />
          </svg>
        </div>
      </div>
      <div>
        <figure class="card-image">
          <img src="${imageURL}" alt="food-image" class="card-item" onerror="this.onerror=null; this.src='${0, (/*@__PURE__*/$parcel$interopDefault($5KXXR))}'" />
        </figure>
        <div class="card-text">
          <p class="tertiary-title card-name" title="${name}">${name}</p>
          <div class="main-desc card-desc">
            <span>$ ${price}</span>
            <span class="circle">&#8729;</span>
            <span>${quantity} Bowls</span>
          </div>
        </div>
      </div>
      <div>
        <a href="product.html?id=${id}" class="btn btn-edit">
          <svg width="20" height="20">
            <use xlink:href="${0, (/*@__PURE__*/$parcel$interopDefault($fKiV7))}#edit-icon" />
          </svg>
          Edit dish
        </a>
      </div>
    </div>
  `;
    }
    /**
   * Renders a form for creating a product.
   */ renderProductFormPage(data = {}) {
        const { id: id, name: name = "", price: price = "", imageURL: imageURL = "", quantity: quantity = "" } = data;
        const formInputs = [
            {
                field: "Name",
                value: name,
                id: "name"
            },
            {
                field: "Price",
                value: price,
                id: "price",
                type: "number"
            },
            {
                field: "Image URL",
                value: imageURL,
                id: "image-url"
            },
            {
                field: "Quantity",
                value: quantity,
                id: "quantity",
                type: "number"
            }
        ];
        const headingPage = Object.keys(data).length === 0 ? (0, $ez1WD.MESSAGES).ADD_PRODUCT_HEADING : (0, $ez1WD.MESSAGES).EDIT_PRODUCT_HEADING;
        const formContent = document.getElementById("form-content");
        formContent.innerHTML = `
      <div class="form-wrapper">
        <h2 class="main-title form-heading">${headingPage}</h2>
        <form data-product-id="${id}" id="product-form" action="javascript:void(0)" class="form-control">
          ${(0, $d0CfO.default)(formInputs)}
          <div class="form-button">
            <a href="/" class="btn btn-primary btn-confirm" >
              Cancel
            </a>
            <button
              class="btn btn-secondary btn-confirm"
              type="submit"
              id="button-submit">
              Save
            </button>
          </div>
        </form>
      </div>
    `;
    }
    /**
   * Creates and appends a delete confirmation modal to the DOM
   */ renderDeleteModal() {
        const deleteModal = document.createElement("div");
        deleteModal.id = "delete-product-modal";
        deleteModal.className = "delete-modal";
        deleteModal.innerHTML = `
      <div class="delete-modal-content">
        <p class="delete-modal-text">Are you sure you want to delete this product?</p>
        <div class="delete-modal-button">
          <button class="btn btn-primary btn-confirm" type="button" id="cancel-btn-delete">Cancel</button>
          <button class="btn btn-secondary btn-confirm" type="button" id="confirm-btn-delete">Yes</button>
        </div>
      </div>
    `;
        document.body.appendChild(deleteModal);
    }
    /**
   * Show the delete product modal and set the dataset for confirmation.
   * @param {string} productId - The ID of the product to be deleted.
   */ toggleDeleteModal = (productId)=>{
        const deleteModal = document.getElementById("delete-product-modal");
        if (!deleteModal) this.renderDeleteModal();
        const confirmBtn = document.getElementById("confirm-btn-delete");
        if (confirmBtn) confirmBtn.dataset.productId = productId;
    };
    /**
   * Binds event listener to toggle the delete product modal when clicking on delete product icons.
   */ bindToggleModal = ()=>{
        const productList = document.querySelector("#product-list");
        productList.addEventListener("click", (event)=>{
            const deleteIcon = event.target.closest(".delete-product-icon");
            if (deleteIcon) {
                const id = deleteIcon.dataset.productId;
                this.toggleDeleteModal(id);
            }
        });
    };
    /**
   * Bind events for delete modal confirmation and cancellation.
   * @param {Function} handleConfirmDelete - Callback function to handle delete confirmation.
   */ bindDeleteModalEvents = (handleConfirmDelete)=>{
        document.addEventListener("click", async (event)=>{
            const confirmBtn = event.target.closest("#confirm-btn-delete");
            const cancelBtn = event.target.closest("#cancel-btn-delete");
            if (confirmBtn) {
                const id = confirmBtn.dataset.productId;
                await handleConfirmDelete(id);
                this.removeDeleteModal();
            }
            if (cancelBtn) this.removeDeleteModal();
        });
    };
    /**
   * Removes the delete modal from the DOM.
   */ removeDeleteModal = ()=>{
        const deleteModal = document.getElementById("delete-product-modal");
        deleteModal.remove();
    };
    /**
   * Binds the search input to the search handler function and render the results.
   * @param {Function} handlerSearchProduct - The handler function to fetch and return search results.
   */ bindSearchProduct = (handlerSearchProduct)=>{
        const searchInput = document.getElementById("input-search");
        if (!searchInput) return;
        searchInput.addEventListener("input", (0, $91ZXl.default)(async (e)=>{
            const name = e.target.value.trim();
            await handlerSearchProduct({
                name: name
            });
        }, 300));
    };
    /**
   * Binds the event for sorting products.
   * @param {Function} handlerSort - The callback function to handle sorting.
   */ bindSortProducts = (handlerSort)=>{
        const sortDropdown = document.querySelector(".sort-list");
        if (sortDropdown) sortDropdown.addEventListener("change", (e)=>{
            const selectedOption = e.target.selectedOptions[0];
            if (selectedOption) {
                const sortBy = selectedOption.getAttribute("data-sort-by");
                const order = selectedOption.getAttribute("data-order");
                handlerSort({
                    sortBy: sortBy,
                    order: order
                });
            }
        });
    };
    /**
   * Show the loading indicator.
   * @param {boolean} isHidden - A flag indicating whether the indicator should be hidden.
   */ toggleIndicator(isHidden) {
        const indicatorElement = document.querySelector(".indicator");
        indicatorElement.classList.toggle("hidden", !isHidden);
    }
}

});
parcelRegister("fKiV7", function(module, exports) {
module.exports = new URL("icons.c7cf762d.svg", import.meta.url).toString();

});

parcelRegister("d0CfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9788f2e473b71b84$export$2e2bcd8739ae039);
/**
 * Render HTML markup for form inputs based on the provided formInputs array.
 * @param {Object[]} formInputs - An array of objects containing field and id properties.
 * @returns {string} - The HTML markup for the form inputs.
 */ const $9788f2e473b71b84$var$renderFormInputTemplate = (formInputs)=>{
    let formInputsHTML = "";
    for (const item of formInputs){
        const { field: field, id: id, value: value = "", type: type = "text" } = item;
        formInputsHTML += `
      <div class="form-group">
        <label for="${id}" class="tertiary-title">${field}</label>
        <input class="input-form input-form-lg" id="${id}" type="${type}" value="${value}" data-field="${field}"/>
        <div class="error-message" id="${id}-error" data-field-error="${field}"></div>
      </div>
    `;
    }
    return formInputsHTML;
};
var $9788f2e473b71b84$export$2e2bcd8739ae039 = $9788f2e473b71b84$var$renderFormInputTemplate;

});

parcelRegister("91ZXl", function(module, exports) {

$parcel$export(module.exports, "default", () => $69344446a0ab500e$export$2e2bcd8739ae039);
/**
 * Debounces a function to limit its execution frequency.
 * @param {Function} func - The function to debounce.
 */ function $69344446a0ab500e$var$debounce(func, delay) {
    let timeoutId;
    return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            func.apply(this, args);
        }, delay);
    };
}
var $69344446a0ab500e$export$2e2bcd8739ae039 = $69344446a0ab500e$var$debounce;

});

parcelRegister("5KXXR", function(module, exports) {
module.exports = new URL("default.fe7fbfff.png", import.meta.url).toString();

});


parcelRegister("8XpGc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6857c0e27be94e44$export$2e2bcd8739ae039);
/**
 * Handles the click event on a navigation link item.
 * @param {Event} event - The click event triggered by the navigation link.
 */ function $6857c0e27be94e44$var$handleNavLinkClick(event) {
    const navLinkItem = event.target.closest(".nav-item");
    if (navLinkItem && !navLinkItem.classList.contains("active")) {
        const activeNavItem = document.querySelector(".nav-item.active");
        if (activeNavItem) activeNavItem.classList.remove("active");
        navLinkItem.classList.add("active");
    }
}
var $6857c0e27be94e44$export$2e2bcd8739ae039 = $6857c0e27be94e44$var$handleNavLinkClick;

});

var $d0395ef9761d778a$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["lmIQu","product.b26fb28a.js","1gkUF","icons.c7cf762d.svg","9LbqE","default.fe7fbfff.png"]'));


//# sourceMappingURL=product.b26fb28a.js.map
